import { AbsoluteFill, useCurrentFrame, useCurrentScale } from "remotion";
import { CompositionTimings } from "../../utils/timing.ts";
import { getElementsByScene, getEndScene } from "@repo/api/utils/composition";
import { CompositionDto, I2VCompositionProps } from "@repo/api/editor";
import ElementsLayer from "../Element/ElementsLayer.tsx";

type Props = {
  composition: CompositionDto;
  timings: CompositionTimings;
  assetMedias: I2VCompositionProps["assetMedias"];
  isStudio: boolean;
  isPlaying: boolean;
};

export default function EndScene({
  composition,
  assetMedias,
  timings,
  isStudio,
  isPlaying,
}: Props) {
  const elements = getElementsByScene(composition, "endScene");
  const scale = useCurrentScale() || 1;
  const frame = useCurrentFrame();

  const isStackedOnMainScene =
    getEndScene(composition)?.entryTransition?.kind === "STACKED" &&
    frame < (timings.endScene?.entryTransitionFrames ?? 0);

  return (
    <AbsoluteFill className={isStackedOnMainScene ? "" : "bg-black"}>
      {elements.length === 0 && isStudio && !isStackedOnMainScene && (
        <div className="flex h-full w-full items-center justify-center">
          <div
            className="text-gray-300 font-medium"
            style={{
              fontSize: 14 / scale,
              paddingRight: 24 / scale,
              paddingLeft: 24 / scale,
            }}
          >
            Start by adding an element to the end scene
          </div>
        </div>
      )}

      {elements.length > 0 && (
        <ElementsLayer
          elements={elements}
          elementTimings={timings.endScene?.elementTimings ?? {}}
          assetMedias={assetMedias}
          sceneType="endScene"
          isPlaying={isPlaying}
        />
      )}
    </AbsoluteFill>
  );
}
